<template>
  <div>
    <div
      class="preorder-seller-container"
      v-for="(seller, index) in visibleSellers()"
      v-bind:key="index"
    >
      <div>
        <div>
          <div class="preorder-seller-title">
            <div class="preorder-seller-title-text">
              <div>
                <span
                  v-if="seller.isExpand"
                  v-on:click="
                    () => {
                      seller.isExpand = false;
                      $forceUpdate();
                    }
                  "
                  class="material-icons-outlined preorder-seller-expanded-icon"
                  >expand_more</span
                >
                <span
                  v-else
                  v-on:click="
                    () => {
                      seller.isExpand = true;
                      $forceUpdate();
                    }
                  "
                  class="material-icons-outlined preorder-seller-retracted-icon"
                  >expand_more</span
                >
              </div>
              <div>
                <div>Empresa: {{ seller.loj_nomeFantasia }}</div>
                <div>
                  CNPJ:
                  {{
                    `${parse_cnpj(seller.loj_cnpj)}` || "" | VMask("##.###.###/####-##")
                  }}
                </div>
              </div>
            </div>
            <div
              :class="{ 'mobile-hide-buttons': !seller.isExpand }"
              class="preorder-seller-title-buttons"
            >
              <div class="preorder-seller-title-button-total">
                <span class="desktop">Total:</span>
                {{ calculate_total(seller) | currency }}
              </div>
              <div
                class="preorder-seller-title-button-excel"
                @click="generate_pdf(seller.cotacao_id, seller)"
              >
                <div v-show="seller.is_loading_pdf">
                  <img style="height: 3.3vh" src="/images/loader.svg" alt="loading" />
                </div>
                <div
                  style="display: flex; align-items: center"
                  v-show="!seller.is_loading_pdf"
                >
                  <span
                    class="material-icons-outlined preorder-seller-title-button-pdf-icon"
                    >picture_as_pdf</span
                  >
                  PDF
                </div>
              </div>
              <div
                class="preorder-seller-title-button-excel"
                @click.stop="export_store_report(seller)"
              >
                <div v-show="seller.is_loading_excel">
                  <img style="height: 3.3vh" src="/images/loader.svg" alt="loading" />
                </div>
                <div
                  style="display: flex; align-items: center"
                  v-show="!seller.is_loading_excel"
                >
                  <img
                    class="preorder-seller-title-button-excel-icon"
                    src="@/assets/excel.svg"
                    alt="excel"
                  />
                  Excel
                </div>
              </div>
              <div
                class="preorder-seller-title-button-excel"
                @click.stop="uploadExcel(seller)"
              >
                <div v-if="seller.is_uploading_excel">
                  <img style="height: 3.3vh" src="/images/loader.svg" alt="loading" />
                </div>
                <div
                  v-else
                  style="display: flex; align-items: center; gap: 0.4vw; white-space: nowrap"
                  v-show="!seller.is_loading_excel"
                >
                  <span
                    style="color: lightseagreen; margin-right: 5%"
                    class="material-icons-outlined"
                    >file_upload</span
                  >
                  <span class="desktop">Exportar</span> planilha
                </div>
              </div>
              <div
                v-if="partialOrder && type == 'ORDERED' && can('REQUEST_ORDER', 'CREATE')"
                v-on:click="order_pending(seller)"
                class="preorder-seller-title-button-sendorder"
                title="Pedir os produtos que os vendedores desta empresa digitaram depois do último pedido"
              >
                <span style="margin-right: 0.5vw" class="material-icons-outlined desktop"
                  >shopping_cart</span
                >
                Pedir pendentes
              </div>
              <div
                style="margin-right: 2vw"
                v-if="type == 'ORDERED' && has_vf_integration"
                v-on:click="sync_many_orders(seller)"
                class="preorder-seller-title-button-sendorder"
              >
                <span style="margin-right: 0.5vw" class="material-icons-outlined desktop"
                  >autorenew</span
                >
                <p class="desktop">Enviar</p>
                Pedidos VF
              </div>
              <div
                v-if="type == 'ORDERED' && has_sapi_integration"
                v-on:click="sync_many_orders_sapi(seller)"
                class="preorder-seller-title-button-sendorder"
              >
                <span style="margin-right: 0.5vw" class="material-icons-outlined desktop"
                  >autorenew</span
                >
                <p class="desktop">Enviar</p>
                Pedidos
              </div>
            </div>
          </div>
          <div v-if="seller.isExpand">
            <div class="preorder-seller-table-header">
              <div class="preorder-seller-table-cart"></div>
              <div class="preorder-seller-table-number">Nº do Pedido</div>
              <div class="preorder-seller-table-suplier">Fornecedor</div>
              <div class="preorder-seller-table-date">Data Entrega</div>
              <div class="preorder-seller-table-payment">Cond. de Pgto.</div>
              <div class="preorder-seller-table-value">Valor</div>
              <div class="preorder-seller-table-min">Fat. Min.</div>
              <div class="preorder-seller-table-delivery">Tipo de Entrega</div>
            </div>
            <div
              :class="getSpecialBackground(idx)"
              class="preorder-seller-table-row"
              v-for="(provider, idx) in visibleProviders(seller)"
              v-bind:key="idx"
            >
              <div class="preorder-seller-table-cart">
                <div class="postOrder-mobile-header"></div>
                <div>
                  <router-link
                    class="preorder-seller-table-cart"
                    :to="{
                      name: 'lancamento-cliente-monitores-vencedores',
                      params: {
                        id: $route.params.id,
                        sellerid: provider.idVendedor,
                        sid: seller.loj_id,
                        providerid: provider.idFornecedor,
                        cnpj: provider.for_cnpj,
                      },
                    }"
                  >
                    <span class="material-icons-outlined preorder-seller-table-cart-icon"
                      >shopping_cart</span
                    >
                  </router-link>
                  
                </div>
                <div>
                  <span
                      v-if="
                          can('ORDER', 'SEND_NOTIFICATION')
                      "
                      class="material-icons preorder-seller-table-cart-icon"
                      title="Reenviar notificação ao vendedor"
                      @click="resend_notification(provider.id_pedido)"
                  >
                      campaign
                  </span>
                </div>
                
                <div>
                  <span class="cart vf" v-if="has_vf_integration && type == 'ORDERED'">
                    <i
                      class="fas fa-sync-alt"
                      aria-hidden="true"
                      title="Enviar VF"
                      style="margin-left: 1vw"
                      v-show="
                        has_vf_integration &&
                        (!provider.vf_integration_status ||
                          (provider.vf_integration_status &&
                            provider.vf_integration_status != 'INTEGRATED'))
                      "
                      @click="sync_order(provider)"
                    ></i>
                    <i
                      class="fas fa-exclamation-triangle"
                      style="color: red !important"
                      aria-hidden="true"
                      :title="provider.vf_integration_obs || 'Falha de integração'"
                      v-show="
                        has_vf_integration &&
                        provider.vf_integration_status &&
                        provider.vf_integration_status != 'INTEGRATED'
                      "
                      @click="
                        edit_product(provider, seller);
                        showNewProductModal = true;
                      "
                    ></i>
                    <i
                        class="fas fa-check-circle"
                        style="margin-left: 1vw;color: #4caf50 !important"
                        aria-hidden="true"
                        :title="'Sincronizado #' + provider.external_reference"
                        v-show="
                            has_vf_integration &&
                            provider.vf_integration_status &&
                            provider.vf_integration_status == 'INTEGRATED' &&
                            !provider.vf_integration_obs
                        "
                    ></i>
                    <i
                        class="fas fa-exclamation-triangle"
                        style="margin-left: 1vw;color: orange !important"
                        aria-hidden="true"
                        :title="'Sincronizado #' + provider.external_reference + '\nObs: ' + provider.vf_integration_obs"
                        v-show="
                            has_vf_integration &&
                            provider.vf_integration_status &&
                            provider.vf_integration_status == 'INTEGRATED' &&
                            !!provider.vf_integration_obs
                        "
                    ></i>
                  </span>

                  <span class="cart vf" v-if="has_sapi_integration && type == 'ORDERED'">
                    <i
                      class="fas fa-sync-alt"
                      aria-hidden="true"
                      title="Enviar Pedido"
                      v-show="
                        !provider.sapi_integration_status ||
                        (provider.sapi_integration_status &&
                          provider.sapi_integration_status != 'INTEGRATED')
                      "
                      @click="sync_order_sapi(provider)"
                    ></i>
                  </span>

                  <i
                    class="fas fa-sync-alt resync-icon"
                    @click="resyncOrder(provider)"
                    v-show="
                      provider.sapi_integration_obs &&
                      provider.sapi_integration_status &&
                      provider.sapi_integration_status != 'INTEGRATED'
                    "
                  ></i>

                  <i
                    class="fas fa-exclamation-triangle"
                    style="color: red !important; margin-left: 10px"
                    aria-hidden="true"
                    :title="provider.sapi_integration_obs"
                    v-show="
                      provider.sapi_integration_obs &&
                      provider.sapi_integration_status &&
                      provider.sapi_integration_status != 'INTEGRATED'
                    "
                  ></i>

                  <i
                    class="fas fa-check-circle"
                    style="margin-left: 1vw;color: #4caf50 !important"
                    aria-hidden="true"
                    :title="'Sincronizado #' + provider.sapi_external_reference"
                    v-show="
                      provider.sapi_integration_status &&
                      provider.sapi_integration_status == 'INTEGRATED' &&
                      !provider.sapi_integration_obs
                    "
                  ></i>
                  <i
                    class="fas fa-exclamation-triangle"
                    style="margin-left: 1vw;color: orange !important"
                    aria-hidden="true"
                    :title="'Sincronizado #' + provider.sapi_external_reference + '\nObs: ' + provider.sapi_integration_obs"
                    v-show="
                      provider.sapi_integration_status &&
                      provider.sapi_integration_status == 'INTEGRATED' &&
                      !!provider.sapi_integration_obs
                    "
                  ></i>
                </div>
              </div>
              <div class="preorder-seller-table-number">
                {{ provider.id_pedido }}
              </div>
              <div class="preorder-seller-table-suplier">
                <!-- <div class="postOrder-mobile-header">Fornecedor</div> -->
                <div style="text-align: start">
                  {{ provider.nomeFornecedor }}<br>
                  {{ provider.for_cnpj | VMask("## ### ###/####-##") }}
                  <div
                    class="mobile-justify"
                    style="display: flex; align-items: center; font-weight: normal"
                  >
                    <div
                      class="preorder-zap-container"
                      :class="{ 'preorder-zap-hover': provider.telefone }"
                    >
                      <i class="fab fa-whatsapp"></i>
                      <a
                        v-if="provider.telefone"
                        class="preorder-zap-link"
                        :href="
                          'https://api.whatsapp.com/send?phone=' +
                          formatNumber(provider.telefone)
                        "
                        target="_blank"
                        >{{ provider.telefone | VMask("(##) ####-#####") }}</a
                      >
                      <div v-else>(xx) xxxxx-xxxxx</div>
                    </div>
                    <div class="preorder-seller-seller-name">
                      - ({{ provider.nomeVendedor }})
                    </div>
                  </div>
                </div>
              </div>

              <div class="preorder-seller-table-data-payment">
                <div class="preorder-seller-table-data-inside">
                  <div class="postOrder-mobile-header">Data Entrega</div>
                  {{
                    provider.entrega ? provider.entrega.data_entrega : "" | formatDateOnly
                  }}
                </div>
                <div class="preorder-seller-table-payment-inside">
                  <div class="postOrder-mobile-header">Cond. de Pgto.</div>
                  {{ provider.entrega ? provider.entrega.forma : "" }}
                </div>
              </div>

              <div class="preorder-seller-table-value-min">
                <div class="preorder-seller-table-value-inside">
                  <div class="postOrder-mobile-header">Valor</div>
                  <div :style="getValueStyle(provider)">
                    {{ provider.valorTotal | currency }}
                  </div>
                </div>
                <div class="preorder-seller-table-payment-inside">
                  <div class="postOrder-mobile-header">Fat. Min.</div>
                  {{
                    provider.entrega
                      ? parseFloat(provider.entrega.faturamento_minimo)
                      : "" | currency
                  }}
                </div>
              </div>

              <div class="preorder-seller-table-delivery">
                <div class="postOrder-mobile-header">Tipo de Entrega</div>
                {{ provider.tpc_nome }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <new-product-modal
      v-if="product && showNewProductModal"
      :closeDialog="closeNewProductModal"
      :product="product"
      :categories="categories"
      :internal_code_only="true"
      @reload_products="reload"
      @close="product = null"
    />
  </div>
</template>

<script>
import QuotationService from "@/services/QuotationService";
import RequestService from "@/services/v3/request.service";
import OrderService from "@/services/v3/order.service";
import ErrorHandlerService from "@/services/ErrorHandlerService";
import Button from "@/components/ui/buttons/button.component";
import NoDataAvailable from "@/components/utils/no-data.utils";
import { perm_mixin } from "@/mixins/permission.mixin";
import VarejoFacilService from "@/services/VarejoFacilService";
import SapiService from "@/services/SapiService";
import StorageService from "@/services/local-storage.service";
import { loaderMixin } from "@/mixins/sweet-loader.mixin";
import ProductService from "@/services/v2/products.service";
import NewProductModal from "@/modals/new-product/new-product.modal";
import { mapState } from "vuex";
import currencyPrecision from "../../mixins/currencyPrecision";
import { partial_order_mixin } from "@/mixins/partial-order.mixin";
export default {
  mixins: [perm_mixin, loaderMixin, currencyPrecision, partial_order_mixin],
  components: {
    "new-product-modal": NewProductModal,
    ccButton: Button,
    "no-data-available": NoDataAvailable,
  },
  // partialOrder: a cotação está em PEDIDO PARCIAL (CLUB-1443) e a conta tem o
  // recurso — cada empresa ganha "Pedir pendentes".
  props: ["type", "sellers", "wraps", "is_loading", "loadPreOrders", "loadTotalOrders", "partialOrder"],
  data() {
    return {
      showNewProductModal: true,
      svc: new RequestService(),
      productService: new QuotationService(),
      vf_svc: new VarejoFacilService(),
      sapi_svc: new SapiService(),
      prod_svc: new ProductService(),
      storage_svc: new StorageService(),
      order_svc: new OrderService(),
      collapsed: [],
      is_loading_pdf: false,
      loading_orders: false,
      has_vf_integration: false,
      has_sapi_integration: false,
      orders_completed: 0,
      current_seller: null,
      categories: [],
      product: null,
    };
  },
  computed: {
    ...mapState(["user"]),
  },
  methods: {
    uploadExcel(seller) {
      var input = document.createElement("input");
      input.type = "file";
      input.onchange = (e) => {
        this.$set(seller, "is_uploading_excel", true);
        var file = e.target.files[0];
        let fileName = file.name.split(".")[0];
        this.svc
          .uploadExcel(this.$route.params.id, seller.loj_id, file)
          .then((resp) => {
            this.$set(seller, "is_uploading_excel", false);
            var file = new Blob([resp.data]);
            var fileURL = URL.createObjectURL(file);
            var el = document.getElementById("download-excel");
            el.download = fileName + "-resposta.xlsx";
            el.href = fileURL;
            el.click();
            setTimeout(function () {
              window.URL.revokeObjectURL(fileURL);
            }, 1000);
          })
          .catch((error) => {
            console.log(error);
            this.$set(seller, "is_uploading_excel", false);
            this.snack("Desculpe, não foi possivel exportar o arquivo", "error");
          });
      };
      input.click();
    },
    getValueStyle(provider) {
      if (provider.entrega && provider.entrega.faturamento_minimo > provider.valorTotal)
        return "background-color: lightcoral; padding: 2px 1vw; width: fit-content; border-radius: 8px; color: white";
      return "background-color: #30AA4C; padding: 2px 1vw; width: fit-content; border-radius: 8px; color: white";
    },
    getSpecialBackground(idx) {
      if (idx % 2 != 0) return "page-table-line-special";
    },
    closeNewProductModal: function () {
      this.showNewProductModal = false;
    },
    reload() {
      this.loadPreOrders().then(() => {
        let curr = this.sellers.find((s) => s.loj_id == this.current_seller.loj_id);
        if (curr) {
          curr.expanded = true;
        }
        this.$forceUpdate();
      });
    },
    edit_product(seller, current) {
      if (seller.edi_children) {
        let di = seller.edi_children.find((d) => d.status == "FAILED");
        if (di) {
          this.prod_svc.load(di.data_id).then((response) => {
            this.product = response.data;
            this.current_seller = current;
          });
        }
      }
    },
    can_sync_all_vf(seller) {
      return this.visibleProviders(seller).some(
        (p) =>
          !p.vf_integration_status ||
          (p.vf_integration_status && p.vf_integration_status != "INTEGRATED")
      );
    },
    can_sync_all_sapi(seller) {
      return this.visibleProviders(seller).some(
        (p) =>
          !p.sapi_integration_status ||
          (p.sapi_integration_status && p.sapi_integration_status != "INTEGRATED")
      );
    },
    parse_cnpj: function (val) {
      return val && `${val}`.length < 14 ? `0${val}` : val;
    },
    calculate_total(seller) {
      let result = 0;
      this.visibleProviders(seller).forEach((p) => (result += p.valorTotal));
      return result;
    },
    ordered_providers(seller) {
      return seller.fornecedores.filter((p) => p.possuiPedido > 0);
    },
    formatNumber(number) {
      if (!number) return null;
      number = number.replace("+", "").replace("(", "").replace(")", "").replace("-", "");
      if (number[0] + "" + number[1] != "55") number = "55" + number;
      return number;
    },
    unordered_providers(seller) {
      return seller.fornecedores.filter((p) => p.possuiPedido == 0);
    },
    expandSeller(seller) {
      this.$set(seller, "expanded", !seller.expanded);
    },
    order(seller) {
      this.current_seller = seller;
      this.$swal
        .fire({
          title: "Confirma realização do pedido?",
          text: "Seu pedido será enviado ao fornecedor!",
          type: "warning",
          showCancelButton: true,
          confirmButtonColor: "#3085d6",
          cancelButtonColor: "#d33",
          confirmButtonText: "Sim, realizar pedido!",
        })
        .then(async (result) => {
          if (result.value) {
            const visible_sellers = this.visibleProviders(seller);

            const haserror = false;
            this.loading_orders = true;
            for (let i = 0; i < visible_sellers.length; i++) {
              let p = visible_sellers[i];

              let data = {
                idcotacao: this.$route.params.id,
                loja: seller.loj_id,
                idvendedor: p.idVendedor,
              };

              let response = await this.productService.order(data);

              if (response.status >= 400) {
                this.$swal.fire("Erro!", response?.data?.mensagem ?? "Ocorreu um erro ao realizar o pedido.", "error");
                haserror = true;
              } else {
                this.orders_completed += 1;
              }
            }
            if (!haserror) {
              this.$swal.fire(
                "Recarregando informações!",
                "Pedidos realizados com sucesso.",
                "success"
              );
            }
            this.loading_orders = false;
            this.loadTotalOrders();
            this.loadPreOrders();
          }
        });
    },
    /**
     * Pedido parcial (CLUB-1443): o pré-pedido do legado lista a loja/vendedor
     * que já tem pedido só aqui, em Pedidos, mesmo quando o vendedor digitou
     * mais produtos depois. Pede o que ficou pendente para esses vendedores;
     * sem nada pendente o kyojin responde 422 e a mensagem dele é mostrada.
     */
    order_pending(seller) {
      const seller_ids = this.visibleProviders(seller).map((p) => p.idVendedor);

      return this.partial_order_round(
        this.$route.params.id,
        { store_id: seller.loj_id, seller_ids },
        {
          title: "Pedir produtos pendentes?",
          text: `Serão pedidos os produtos vencedores ainda não pedidos aos vendedores de ${seller.loj_nomeFantasia}, em pedidos novos.`,
        },
        {
          start: () => (this.loading_orders = true),
          finish: () => {
            this.loading_orders = false;
            this.$emit("partial-order-done");
            this.loadTotalOrders();
            this.loadPreOrders();
          },
        }
      );
    },
    cancel(seller) {
      this.$swal
        .fire({
          title: "Confirma cancelamento do pedido?",
          text: "Seu pedido será cancelado!",
          type: "warning",
          showCancelButton: true,
          confirmButtonColor: "#3085d6",
          cancelButtonColor: "#d33",
          confirmButtonText: "Sim, cancalar pedido!",
        })
        .then((result) => {
          if (result.value) {
            var providers = this.ordered_providers(seller);

            this.visibleProviders(seller).forEach(async (p, i) => {
              let data = {
                numeroCotacao: this.$route.params.id,
                loja: seller.loj_id,
                vendedor: p.idVendedor,
              };
              await this.productService
                .cancel_order(data)
                .then((response) => response.data)
                .then(
                  (data) => {
                    if (i + 1 == providers.length) {
                      this.$swal.fire(
                        "Recarregando informações!",
                        "Seu pedido foi cancelado com sucesso.",
                        "success"
                      );
                      this.is_loading = false;
                      this.loadTotalOrders();
                      this.loadPreOrders();
                    }
                  },
                  (err) => {
                    if (i + 1 == providers.length) {
                      this.$swal.fire(
                        "Erro!",
                        "Ocorreu um erro ao cancelar o pedido.",
                        "error"
                      );
                    }
                  }
                );
            });
          }
        });
    },
    sync_order(item) {
      this.present_loader("Enviando pedido...");
      this.vf_svc
        .export(item.id_pedido)
        .then((response) => response.data)
        .then((data) => {
          this.dismiss_loader();
          const notification = {
            type: "success",
            message: "Pedido enviado com sucesso!",
          };
          this.$store.dispatch("notification/add", notification);
          this.reload();
        })
        .catch((e) => {
          console.log(e.response.data.message);
          this.dismiss_loader();
          if (e.response.data.message) {
            const notification = {
              type: "error",
              message: e.response.data.message,
            };
            this.$store.dispatch("notification/add", notification);
          }
          this.reload();
        });
    },
    resyncOrder(provider) {
      this.$swal
        .fire({
          title: "Deseja sincronizar novamente este pedido?",
          text: "Esta operação ira enviar o pedido novamente para a retaguarda.",
          icon: "warning",
          showCancelButton: true,
          confirmButtonColor: "#3085d6",
          cancelButtonColor: "#d33",
          confirmButtonText: "Sim, sincronizar novamente.",
        })
        .then((resp) => {
          if (!resp.isConfirmed) return;
          this.present_loader("Ressincronizando...");
          this.svc.resyncOrder(provider.id_pedido).then((resp2) => {
            this.dismiss_loader();
            this.reload();
          });
        });
    },
    sync_order_sapi(item) {
      this.present_loader("Enviando pedido...");
      this.sapi_svc
        .export(item.id_pedido)
        .then((response) => response.data)
        .then((data) => {
          this.dismiss_loader();
          const notification = {
            type: "success",
            message: "Pedido enviado com sucesso!",
          };
          this.$store.dispatch("notification/add", notification);
          this.reload();
        })
        .catch((e) => {
          this.dismiss_loader();
          if (e.response.data.message) {
            const notification = {
              type: "error",
              message: "Não foi possível sincronizar o pedido!",
            };
            this.$store.dispatch("notification/add", notification);
          }
          this.reload();
        });
    },
    sync_many_orders(seller) {
      let ids = this.visibleProviders(seller)
        .filter(
          (p) =>
            !p.vf_integration_status ||
            (p.vf_integration_status && p.vf_integration_status != "INTEGRATED")
        )
        .map((p) => p.id_pedido);
      if (ids) {
        this.present_loader("Enviando pedidos...");
        this.vf_svc
          .export_many(ids)
          .then((response) => response.data)
          .then((data) => {
            this.dismiss_loader();
            this.present_info(
              "Solicitação enviada com sucesso, seus pedidos serão processados em background, verifique novamente em algums minutos!"
            );
            this.loadPreOrders();
          })
          .catch((e) => {
            console.log(e.response.data.message);
            this.dismiss_loader();
            if (e.response.data.message) {
              const notification = {
                type: "error",
                message: e.response.data.message,
              };
              this.$store.dispatch("notification/add", notification);
            }
            this.reload();
          });
      } else {
        this.present_loader("Nenhum pedido dispon'i'vel para integração");
      }
    },
    sync_many_orders_sapi(seller) {
      let ids = this.visibleProviders(seller)
        .filter(
          (p) =>
            !p.sapi_integration_status ||
            (p.sapi_integration_status && p.sapi_integration_status != "INTEGRATED")
        )
        .map((p) => p.id_pedido);
      if (ids) {
        this.present_loader("Enviando pedidos...");
        this.sapi_svc
          .export_many(ids)
          .then((response) => response.data)
          .then((data) => {
            this.dismiss_loader();
            this.present_info(
              "Solicitação enviada com sucesso, seus pedidos serão processados em background, verifique novamente em algums minutos!"
            );
            this.loadPreOrders();
          })
          .catch((e) => {
            console.log(e.response.data.message);
            this.dismiss_loader();
            if (e.response.data.message) {
              const notification = {
                type: "error",
                message: e.response.data.message,
              };
              this.$store.dispatch("notification/add", notification);
            }
            this.reload();
          });
      } else {
        this.present_loader("Nenhum pedido dispon'i'vel para integração");
      }
    },
    visibleSellers() {
      return this.sellers
        .filter(
          (s) =>
            this.can("REQUEST", "READ_ALL_SUBREQUESTS") || s.loj_id == this.user.store_id
        )
        .filter((s) => s.visible && this.visibleProviders(s).length > 0)
        .sort((s1, s2) => s1.loj_numeroLoja - s2.loj_numeroLoja);
    },
    visibleProviders(seller) {
      let result = [];

      result = result.concat(
        seller.fornecedores
          .filter((s) => this.isVisible(s) && s.entrega)
          .sort((a, b) => {
            let f1 = a.nomeFornecedor;
            let f2 = b.nomeFornecedor;
            if (f1 < f2) return 1;
            if (f2 > f1) return -1;
            return 0;
          })
      );

      result = result.concat(
        seller.fornecedores.filter((s) => this.isVisible(s) && !s.entrega)
      );

      return result;
    },
    isVisible(provider) {
      if (
        // possuiPedido conta pedidos: com pedido parcial pode passar de 1.
        (provider.possuiPedido > 0 && this.type == "ORDERED") ||
        (provider.possuiPedido == 0 && this.type == "NOT_ORDERED")
      ) {
        return true;
      } else {
        return false;
      }
    },
    export_store_report(seller) {
      this.$set(seller, "is_loading_excel", true);

      this.svc
        .export_store_report(this.$route.params.id, seller.loj_id)
        .then((response) => response.data)
        .then((data) => {
          const blob = new Blob([data], { type: "application/vnd.ms-excel" });
          const url = window.URL.createObjectURL(blob);

          const link = document.createElement("a");
          link.href = url;
          link.download = `Conferencia-${seller.loj_nomeFantasia}-${this.$route.params.id}.xls`;

          document.body.appendChild(link);

          link.click();

          setTimeout(() => {
            document.body.removeChild(link);
            window.URL.revokeObjectURL(url);
          }, 100);
          this.$set(seller, "is_loading_excel", false);
        })
        .catch((error) => {
          this.$set(seller, "is_loading_excel", false);
          ErrorHandlerService.handle(error, this.$store);
        });
    },
    async generate_pdf(numeroSolicitacao, seller) {
      this.$set(seller, "is_loading_pdf", true);
      try {
        const response = await this.productService.generate_pdf(
          this.$route.params.id,
          numeroSolicitacao
        );
        const blob = new Blob([response.data], { type: "application/pdf" });
        const url = window.URL.createObjectURL(blob);

        const link = document.createElement("a");
        link.href = url;
        link.download = `Conferencia-${seller.loj_nomeFantasia}-${this.$route.params.id}.pdf`;
        document.body.appendChild(link);

        link.click();
        setTimeout(() => {
          document.body.removeChild(link);
          window.URL.revokeObjectURL(url);
        }, 100);
      } catch (error) {
        ErrorHandlerService.handle(error, this.$store);
      } finally {
        this.$set(seller, "is_loading_pdf", false);
      }
    },
    print() {
      self.print();
    },
    toggle_collapse(index) {
      this.$set(this.collapsed, index, !this.collapsed[index]);
    },
    processCollapse() {
      if (this.type == "NOT_ORDERED") {
        this.sellers.forEach((s) => (s.expanded = false));
      } else {
        this.sellers.forEach((s) => (s.expanded = true));
      }
    },
    formatPrice(value) {
      let val = (value / 1).toFixed(2).replace(".", ",");
      return "" + val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
    },
    check_vf_integration() {
      let has_vf_integration = StorageService.get_string("has_vf_integration");
      if (has_vf_integration) {
        this.has_vf_integration = !!has_vf_integration;
      }
    },
    check_order_integration() {
      let settings = JSON.parse(StorageService.get_string("user_settings"));
      if (settings) {
        let external_user = settings.find((s) => s.key == "EXTERNAL_USER");
        let external_pass = settings.find((s) => s.key == "EXTERNAL_PASSWORD");
        let external_domain = settings.find((s) => s.key == "EXTERNAL_SUBDOMAIN");
        if (external_user && external_pass && external_domain) {
          this.has_sapi_integration = true;
        }
      }
    },
    resend_notification(order_id) {
        this.confirm_action({
            message: "Confirma envio de notificação?",
            subtitle: "O vendedor será novamente notificado sobre este pedido!",
            callback: () => {
                this.order_svc
                    .notifyMany([order_id])
                    .then(({ data }) => {
                        if (!data.notified.length) {
                            this.present_error("Não foi possível reenviar a notificação deste pedido.");
                            return;
                        }
                        this.present_info("Notificação reenviada com sucesso!");
                    })
                    .catch((error) => {
                        ErrorHandlerService.handle(error, this.$store);
                    });
            },
        });
    },
  },
  mounted() {
    this.check_vf_integration();
    this.check_order_integration();
  },
};
</script>

<style scoped>
.preorder-seller-container {
  border: 1px solid lightgray;
  border-radius: 8px;
  padding: 1vh 1vw;
  font-size: 1rem;
  margin-bottom: 4vh;
}
p {
  margin-bottom: 0;
  margin-right: 0.5vw;
}
.preorder-seller-title {
  display: flex;
  justify-content: space-between;
}
.preorder-seller-title-text {
  font-weight: 400;
  font-size: 1rem;
  color: #606060;
  display: flex;
  max-width: 26%;
  text-transform: uppercase;
}
.preorder-seller-title-buttons {
  display: flex;
  align-items: center;
  gap: 1vw;
}
.preorder-seller-title-button-total {
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(23, 162, 184, 0.1);
  border: 1px solid #e5e5e5;
  border-radius: 9.5px;
  font-weight: 600;
  font-size: 1rem;
  color: #5281ff;
  padding: 1vh 1.5vw;
  margin-right: 1vw;
  gap: 1vw;
}
.preorder-seller-table-header {
  display: flex;
  background: #fffefc;
  border: 0.5px solid #e5e5e5;
  padding: 1vh 0;
  margin: 1vh 0;
  font-weight: 600;
  font-size:0.8rem;
  color: #505050;
}
.preorder-seller-table-cart {
  min-width: 7%;
  display: flex;
}

.preorder-seller-table-number {
  min-width: 10%;
}
.postOrder-mobile-header {
  display: none;
}
.preorder-seller-table-suplier {
  flex: 1;
  font-weight: bold;
}
.preorder-seller-table-date {
  width: 15%;
}
.preorder-seller-table-payment {
  width: 12%;
}
.preorder-seller-table-data-payment {
  width: 27%;
  display: flex;
}
.preorder-seller-table-data-inside {
  width: 56%;
}
.preorder-seller-table-value {
  width: 12%;
}
.preorder-seller-table-min {
  width: 12%;
}
.preorder-seller-table-value-min {
  width: 24%;
  display: flex;
}
.preorder-seller-table-value-inside {
  width: 50%;
}
.preorder-seller-table-delivery {
  width: 12%;
}
.preorder-seller-table-row {
  display: flex;
  font-weight: 300;
  font-size: 0.8rem;
  color: #605f5f;
  padding: 1vh 0;
}
.preorder-seller-seller-name {
  font-size: 0.8em;
}
.preorder-seller-table-cart-icon {
  color: var(--primary-color);
  cursor: pointer;
  font-size: 1rem;
  margin-left: 0.5vw;
  border: var(--primary-color) 3px solid;
  border-radius: 10px;
  padding: 0.3vw;
  box-shadow: 2px 2px 3px;
}
.preorder-seller-retracted-icon {
  color: #fe6700;
  transform: rotate(-90deg);
  font-size: 1.8rem;
  cursor: pointer;
}
.preorder-seller-expanded-icon {
  color: #fe6700;
  font-size: 1.8rem;
  cursor: pointer;
}
.preorder-seller-title-button-sendorder {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.5vw;
  border: 1px solid #e5e5e5;
  border-radius: 9.5px;
  padding: 1vh 1.5vw;
  font-weight: 600;
  font-size: 1rem;
  color: #5281ff;
  cursor: pointer;
  gap: 1vw;
}
.preorder-zap-container {
  display: flex;
  align-items: center;
  padding: 5px 5px;
  gap: 5px;
  font-size: 0.9em;
}
.preorder-zap-link {
  color: #4ac959;
}
.preorder-zap-hover {
  color: #4ac959;
}
.resync-icon {
  margin-left: 1vw;
  cursor: pointer;
}
.preorder-zap-hover:hover {
  background: #4ac959;
  color: white;
  border-radius: 5px;
}
.preorder-zap-hover:hover > .preorder-zap-link {
  color: white;
}
.preorder-seller-title-button-excel {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.6vw;
  border: 1px solid #e5e5e5;
  border-radius: 9.5px;
  padding: 1vh 1.5vw;
  font-weight: 600;
  font-size: 1rem;
  cursor: pointer;
  height: auto;
  min-width: 9vw;
  margin-right: 1vw;
}
.preorder-seller-title-button-excel-icon {
  margin-right: 1vw;
}
.preorder-seller-title-button-pdf-icon {
  color: #ef443b;
  margin-right: 1vw;
}
.preorder-seller-table-send-icon {
  cursor: pointer;
  color: #4267b2;
  margin-left: 1vw;
}
.page-table-line-special {
  background-color: #f7f7f7 !important;
}
@media only screen and (max-width: 1000px) {
  .preorder-seller-container {
    font-size: 1.5vw;
  }
  .preorder-seller-title-button-excel {
    width: 180px;
  }
}
@media only screen and (max-width: 850px) {
  .preorder-seller-container {
    font-size: 2vw;
  }
  .preorder-seller-title {
    flex-direction: column;
  }
  .preorder-seller-title-text {
    max-width: 100%;
  }
  .mobile-hide-buttons {
    display: none;
  }
  .mobile-justify {
    flex-wrap: wrap;
  }
  .preorder-seller-table-cart-icon {
    padding: 1vh 6vw;
  }
}
@media only screen and (max-width: 550px) {
  .preorder-seller-container {
    font-size: 2.5vw;
  }
  .desktop {
    display: none;
  }
  .preorder-seller-title-buttons {
    justify-content: space-between;
    gap: 0.5vw;
  }
  .preorder-seller-table-data-payment {
    justify-content: space-between;
    width: 100%;
  }
  .preorder-seller-table-value-min {
    justify-content: space-between;
    width: 100%;
  }
  .preorder-seller-table-data-inside {
    display: flex;
    gap: 10%;
    align-items: center;
  }
  .preorder-seller-table-value-inside {
    display: flex;
    gap: 10%;
    align-items: center;
  }
  .preorder-seller-table-payment-inside {
    display: flex;
    gap: 10%;
    flex: 1;
    justify-content: flex-end;
    align-items: center;
  }
  .preorder-seller-title-button-total {
    display: flex;
    justify-content: center;
    margin-right: 0;
  }
  .preorder-seller-title-button-excel {
    margin-right: 0;
    width: fit-content;
    display: flex;
    justify-content: center;
    padding: 0 1.5%;
    width: 25%;
  }
  .preorder-seller-title-button-sendorder {
    display: flex;
    justify-content: center;
  }
  .preorder-seller-table-header {
    display: none;
  }
  .preorder-seller-table-row {
    margin-top: 3vh;
    flex-direction: column;
    gap: 2vh;
    font-size: 1rem;
  }
  .preorder-seller-table-cart {
    justify-content: space-between;
    margin-bottom: 1vh;
  }
  .postOrder-mobile-header {
    display: flex;
    font-size: 1rem;
    color: #605f5f;
  }
  .preorder-seller-table-suplier {
    display: flex;
    justify-content: space-between;
    text-align: end;
  }
  .preorder-seller-table-date {
    display: flex;
    justify-content: space-between;
    width: 100%;
  }
  .preorder-seller-table-payment {
    display: flex;
    justify-content: space-between;
    width: 100%;
  }
  .preorder-seller-table-value {
    display: flex;
    justify-content: space-between;
    width: 100%;
  }
  .preorder-seller-table-min {
    display: flex;
    justify-content: space-between;
    width: 100%;
  }
  .preorder-seller-table-delivery {
    display: flex;
    justify-content: space-between;
    width: 100%;
  }
}
@media only screen and (max-width: 410px) {
  .preorder-seller-container {
    font-size: 3vw;
  }
}
@media print {
  .preorder-seller-table-header {
    break-inside: avoid;
  }
  .preorder-seller-table-row {
    break-inside: avoid;
  }
  @page {
    margin: 3%;
  }
}
</style>
